import Dashboard from '../../../../../baseComponents/Dashboard'
import { getEmployeeParams } from '../../../../../utils/reducers/getters'

const LogisticDashboard: React.FC = () => {
    const defaultStyle = getEmployeeParams()?.['appStyle'] || 'new1'
    const defaultWidgets = {
        default: [{ "cols": 1, "rows": 1, "name": "quote_pending_amount" }, { "cols": 1, "rows": 1, "name": "quote_accepted_amount" }, { "cols": 2, "rows": 3, "name": "quote_multiple_chart_data" }, { "cols": 2, "rows": 2, "name": "quote_status_progress_bar" }, { "cols": 2, "rows": 2, "name": "quote_status_percentage" }, { "cols": 2, "rows": 2, "name": "quote_days_totalvsaccepted" }],
        new1: [{ "cols": 1, "rows": 1, "name": "quote_pending_amount" }, { "cols": 1, "rows": 1, "name": "quote_accepted_amount" }, { "cols": 3, "rows": 3, "name": "quote_multiple_chart_data" }, { "cols": 2, "rows": 2, "name": "quote_status_progress_bar" }, { "cols": 2, "rows": 2, "name": "quote_status_percentage" }, { "cols": 3, "rows": 2, "name": "quote_days_totalvsaccepted" }]
    }
    
    const props = {
        name: 'dashboard_logistic_distribution',
        defaultWidgets: JSON.stringify(defaultWidgets[defaultStyle])
    }
    return (<Dashboard {...props} />)
}

export default LogisticDashboard